@if (isMobile() && items.length > 0 && !isAddressDialogOpen) {
  <div class="mobile-cart">
    <div class="mobile-cart-inner">
      <div class="cart-icon">🛒</div>
      <div class="cart-info">
        <div class="count">{{itemCount}} items added.</div>
        <div class="total">View Cart • {{ netTotal | currency:'INR':'symbol':'1.0-0' }}</div>
      </div>
      <button class="cta" (click)="openCart()">View Cart</button>
    </div>
  </div>
}
